/* Theme preview ONLY: visibly labeled demonstration of review placement.
   This is not a genuine customer review; no review data is created. */
(function(){"use strict";
const THEME="189560062083",HANDLE="w24tthfc-b";
if(!(new URLSearchParams(location.search).get("preview_theme_id")===THEME || window.Shopify&&Shopify.designMode))return;
const TITLE="Coloful Warm Winter Shirt",TAG="SAMPLE REVIEW - LAYOUT TEST ONLY";
function demo(){
 const article=document.createElement("article");article.className="tt-demo-review";
 article.innerHTML='<strong class="tt-demo-review__tag">SAMPLE REVIEW - LAYOUT TEST ONLY</strong><div class="tt-demo-review__stars" aria-label="Sample five-star rating">★★★★★</div><strong>Example customer review</strong><p>Sample text showing how a real customer review will look here. This is not an actual testimonial.</p><small>Preview example • Not customer feedback</small>';
 return article;
}
function mount(){
 const isProduct=location.pathname.includes("/products/"+HANDLE);
 if(isProduct){
  const reviews=document.querySelector(".tt-reviews__list")||document.querySelector(".tt-reviews");
  if(reviews&&!reviews.querySelector(".tt-demo-review"))reviews.append(demo());
 }
 if(location.pathname==="/"||location.pathname===""){
  let area=document.querySelector(".tt-home-reviews__track");
  if(!area){
   const help=document.querySelector(".tt-help")||document.querySelector("#t4s-footer");
   if(help&&!document.querySelector("[data-tt-demo-home]")){
    const section=document.createElement("section");section.className="tt-demo-home t4s-container";section.dataset.ttDemoHome="";
    const head=document.createElement("h2");head.textContent="Customer reviews";
    area=document.createElement("div");area.className="tt-home-reviews__track";
    section.append(head,area);help.parentNode.insertBefore(section,help);
   }
  }
  if(area&&!area.querySelector(".tt-demo-review"))area.append(demo());
 }
 document.querySelectorAll(".t4s-pr-grid[data-product-options],.tt-age-card[data-product-options]").forEach(function(card){
  let meta;try{meta=JSON.parse(card.getAttribute("data-product-options")||"{}")}catch(e){return}
  if(meta.handle!==HANDLE||card.dataset.ttDemoReview==="1")return;
  const info=card.querySelector(".t4s-product-info");if(!info)return;
  const p=document.createElement("div");p.className="tt-demo-rating";p.textContent="★★★★★  Sample review • Preview only";info.append(p);card.dataset.ttDemoReview="1";
 });
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",mount);else mount();
let scheduled=false;new MutationObserver(function(){if(scheduled)return;scheduled=true;requestAnimationFrame(function(){scheduled=false;mount()})}).observe(document.body,{subtree:true,childList:true});
document.addEventListener("shopify:section:load",mount);
})();
